import { FONT_COLOR, FONT_VARIANT } from "../../../fonts/font-props";
import {IButtonProps} from "../../../inputs/button/button";
import { DefaultModalLayout } from "../../layouts/default-modal-layout";
import indicatorSuccess from '../../../../images/indicator-success.svg';
import indicatorFailure from '../../../../images/indicator-failure.svg';
import FontBody1 from "../../../fonts/font-body1/font-body1";
import FontHeading3 from "../../../fonts/font-heading3/font-heading3";
import "./action-result-modal.scss";

interface INotificationModalProps {
    title: React.ReactNode;
    content: React.ReactNode;
    buttons: IButtonProps[],
    success?: boolean;
    onClose: () => void;
    isClosedDisabled?: boolean;
}

export const ActionResultModal: React.FC<INotificationModalProps> = ({
    title,
    content,
    success = true,
    buttons,
    onClose,
    isClosedDisabled = false
}) => {
    const indicatorSrc = success ? indicatorSuccess : indicatorFailure;
    const titleColor = success ? FONT_COLOR.ACCENT1 : FONT_COLOR.ACCENT3;

    return (
        <DefaultModalLayout
            onCloseClicked={onClose}
            isCloseDisabled={isClosedDisabled}
            buttons={buttons}
        >
            <div className="action-result-modal">
                <div className="action-indicator">
                    <img alt="" src={indicatorSrc} />
                </div>
                <div className="notification-modal-title">
                    <FontHeading3
                        variant={[FONT_VARIANT.BOLD]}
                        color={titleColor}
                    >
                        {title}
                    </FontHeading3>
                </div>
                <div className="action-result-modal-content">
                    <FontBody1 color={FONT_COLOR.PRIMARY3}>
                        {content}
                    </FontBody1>
                </div>
            </div>
        </DefaultModalLayout>
    );
}
